
var ResourceInjector = function() {
    var document = window.document;

    var TYPE_SCRIPT = 'script[src*="${url}"]',
        TYPE_LINK = 'link[href*="${url}"]';

    /**
     * Returns a promise that will be run after the load is complete.  The promise will be
     * resolved if the script/link's onload event has already fired.  You should always assume that
     * the script/link has already been injected by another angular mini-app (ie. code defensively).
     *
     * @param element
     * @return promise
     */
    var _createPromise = function(element) {
        return new Promise(function(resolve, reject){
            try{
                if (element && element.getAttribute('data-is-loaded')) {
                    // already loaded
                    resolve({
                        onload: false,
                        message: 'Already loaded'
                    });
                } else {
                    // load event hasn't fired yet
                    $(element)
                        .on('load', function() {
                            element.setAttribute('data-is-loaded', 'true');
                            resolve({
                                onload: true,
                                message: 'Load complete'
                            });
                        })
                        .on('error', function(event) {
                            reject(null, event);
                        });
                }
            } catch(ex) {
                reject(ex);
            }
        });
    };

    /**
     * Installing script to page
     * @param url
     * @param async
     * @private
     */
    var _installScript = function(url, async) {
        var cs = document.createElement('script');
        cs.type = 'text/javascript';
        cs.async = async !== false;
        document.head.appendChild(cs);

        var promise = _createPromise(cs);
        cs.src = url;
        return promise;
    };

    /**
     * Installing link to page
     * @param url
     * @private
     */

    var _installLink = function(url) {
        var cs = document.createElement('link');
        cs.type = 'text/css';
        cs.rel = 'stylesheet';
        document.head.appendChild(cs);

        var promise = _createPromise(cs);
        cs.href = url;
        return promise;
    };

    /**
     * get script or link on page
     * @param type
     * @param url
     * @returns {boolean}
     * @private
     */

    var _getResourceElem = function(type, url) {
        return document.querySelector(type.replace('${url}', url));
    };

    /**
     * Installing script if page doesn't have it
     * @param url
     * @param async
     * @return promise - to be run after the load is complete (the promise already
     *                   may have been resolved, ie. after script's onload event has fired)
     */

    var jsScript = function(url, async) {
        var jsElem = _getResourceElem(TYPE_SCRIPT, url);
        if (!jsElem) {
            return _installScript(url, async);
        } else {
            return _createPromise(jsElem);
        }
    };

    /**
     * Installing link if page doesn't have it
     * @param url
     * @return promise - to be run after the load is complete (the promise already
     *                   may have been resolved, ie. after script's onload event has fired)
     */

    var injectLink = function(url) {
        var linkElem = _getResourceElem(TYPE_LINK, url);
        if (!linkElem) {
            return _installLink(url);
        } else {
            return _createPromise(linkElem);
        }
    };

    return {
        jsScript: jsScript,
        cssLink: injectLink
    };
};


module.exports = new ResourceInjector();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/resource-injector/resource-injector.js
// module id = 440
// module chunks = 36